import React, { Component } from "react";
import "./JobPosting.css";
import { validateComponent, validateField } from "../../common/validation";
import LoadingIndicator from "../../common/LoadingIndicator";
import { API_BASE_URL } from "../../constants";
import { request } from "../../util/APIUtils";

class DetailModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fieldsDisabled: false,
      error: {},
      loading: false,
      jobPosting: {
        jobTitle: "",
        jobDescription: "",
        postedDate: "",
        expiryDate: "",
        contactInfo: "",
        pharmacy: {
          name: "",
        },
      },
    };
  }

  componentDidMount() {
    if (this.props.jobPosting && this.props.jobPosting.id) {
      this.fetchJobDetails(this.props.jobPosting.id);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.jobPosting && prevProps.jobPosting !== this.props.jobPosting && this.props.jobPosting.id) {
      this.fetchJobDetails(this.props.jobPosting.id);
    }
  }

  validateClass = (id) => {
    let error = this.state.error;
    return error[id] === undefined ? "" : error[id].valid ? " has-success" : " has-danger";
  };

  validateMessage = (id) => {
    let error = this.state.error;
    return error[id] === undefined ? "" : error[id].message;
  };

  validateComponent = () => {
    let result = validateComponent(this);
    this.setState({ error: result.error });
    return result;
  };

  validateField = (e) => {
    let id = e.target.id;
    let rule = e.target.dataset.vdata;
    let boundary = e.target.dataset.vlength;
    let value = e.target.value;
    let result = validateField(rule, boundary, value);
    let error = this.state.error;
    error = Object.assign(error, { [id]: result });
    this.setState({ error });
  };

  onChangeJobPosting = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({
      jobPosting: {
        ...this.state.jobPosting,
        [name]: value,
      },
    });
  };

  cancelProcess = () => {
    this.props.cancelProcess();
  };

  fetchJobDetails = (jobId) => {
    const url = `${API_BASE_URL}/jobPosting/${jobId}`;
    this.setState({ loading: true });

    request({ url: url, method: "GET" })
      .then((data) => {
        console.log("API Response Data:", data); // Yanıtı konsola yaz
        this.setState({ jobPosting: data, loading: false });
      })
      .catch((error) => {
        this.setState({ loading: false, error: "Veri çekme hatası." });
        console.error("There was an error with the fetch operation:", error);
      });
  };

  render() {
    const { jobPosting, loading, error } = this.state;
    console.log("baran:", jobPosting);
    return (
      <div className="jobPosting-form-container" style={{ width: "100%" }}>
        {loading && (
          <div className="loader">
            <LoadingIndicator />
          </div>
        )}
        {error && (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        )}
        {jobPosting && (
          <div className="col-sm-12 row mt-3">
            <div className="col-sm-12">
              <div>
                <strong>Görev Adı:</strong> {jobPosting.jobTitle}
              </div>
              <div>
                <strong>İş Tanımı:</strong> {jobPosting.jobDescription}
              </div>
              <div>
                <strong>Yayınlanma Tarihi:</strong> {jobPosting.postedDate}
              </div>
              <div>
                <strong>Geçerlilik Tarihi:</strong> {jobPosting.expiryDate}
              </div>
              <div>
                <strong>İletişim Bilgileri:</strong> {jobPosting.contactInfo}
              </div>
              <div>
                <strong>Eczane Adı:</strong> {jobPosting.pharmacy.name}
              </div>
            </div>
          </div>
        )}
        <div className="modal-footer">
          <div className="col-sm-12 row" id="deleteModal">
            <div className="col-sm-2">
              <button
                type="button"
                data-toggle="tooltip"
                data-placement="bottom"
                style={{
                  background: "#9e9e9e",
                  padding: "10px 54px 10px 23px",
                  width: "150px",
                }}
                rel="tooltip"
                className="TekBtn vazgec"
                onClick={this.cancelProcess}
              >
                İptal
              </button>
            </div>
            <div className="col-sm-8" />
          </div>
        </div>
      </div>
    );
  }
}

export default DetailModal;



// WEBPACK FOOTER //
// ./src/page/jobPosting/DetailModal.js